import { render, staticRenderFns } from "./AiChart.vue?vue&type=template&id=f08373e2&scoped=true"
import script from "./AiChart.vue?vue&type=script&lang=js"
export * from "./AiChart.vue?vue&type=script&lang=js"
import style0 from "./AiChart.vue?vue&type=style&index=0&id=f08373e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08373e2",
  null
  
)

export default component.exports